import { Typography } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { FONT_SIZE, INK, LETTER_SPACING } from "@/theme/tokens";

/** Spans, not headings: SystemDialog's title slot is already the dialog's <h2>. */
export const AnnieStudioTitle: FC = () => {
	const { t } = useTranslation();
	return (
		<>
			<Typography
				component="span"
				sx={{
					display: "block",
					fontSize: FONT_SIZE.LABEL_XS,
					fontWeight: 800,
					letterSpacing: LETTER_SPACING.LABEL,
					textTransform: "uppercase",
					color: INK.MUTED,
				}}
			>
				{t("annie.studio.eyebrow")}
			</Typography>
			<Typography component="span" sx={{ display: "block", fontSize: FONT_SIZE.TITLE_XL, fontWeight: 800, color: INK.PRIMARY, lineHeight: 1.25 }}>
				{t("annie.studio.title")}
			</Typography>
			<Typography component="span" sx={{ display: "block", mt: 0.25, fontSize: FONT_SIZE.SECONDARY, fontWeight: 400, color: INK.MUTED }}>
				{t("annie.studio.subtitle")}
			</Typography>
		</>
	);
};
